import React from 'react';
import ReactDOM from 'react-dom/client';
import { setDefaultOptions } from 'date-fns';
import { fr } from 'date-fns/locale';
import './styles/index.scss';
import createStore, { history } from './createStore.js';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { renderRoutes } from 'react-router-config';
import routes from './routes.js';

setDefaultOptions({ locale: fr });

const store = createStore();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      {renderRoutes(routes)}
    </ConnectedRouter>  
  </Provider>
);
